"use strict";

var _regeneratorRuntime = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var apollo_link_1 = require("apollo-link");

var R = __importStar(require("ramda"));

var utils_1 = require("./utils");

var mutations_1 = require("./graphql/mutations");
/**
 * SignUp Link sends userSignUp mutation on server if user isn't registered
 * @param {SignUpLinkParameters} options - The link\'s options.
 * @param {Function} options.getAuthState - Function which called to get user\'s email and auth token.
 * @param {String} options.authProfileId - Auth Profile Id copied from 8base authentication page.
 */


var SignUpLink =
/*#__PURE__*/
function (_apollo_link_1$Apollo) {
  _inherits(SignUpLink, _apollo_link_1$Apollo);

  function SignUpLink(_ref) {
    var _this;

    var getAuthState = _ref.getAuthState,
        authProfileId = _ref.authProfileId;

    _classCallCheck(this, SignUpLink);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SignUpLink).call(this));
    _this.getAuthState = getAuthState;
    _this.authProfileId = authProfileId;
    _this.signUpPromise = null;
    _this.fetching = false;
    return _this;
  }

  _createClass(SignUpLink, [{
    key: "request",
    value: function request(operation, forward) {
      var _this2 = this;

      return new apollo_link_1.Observable(function (observer) {
        var subscription = null;

        var handleUserNotExistError = function handleUserNotExistError() {
          _this2.sendSignUp(operation, forward).then(function () {
            if (subscription) {
              subscription.unsubscribe();
            }

            subscription = forward(operation).subscribe(subscriber);
          }).catch(function (error) {
            observer.error(error);
          });
        };

        var subscriber = {
          complete: function complete() {
            if (!_this2.fetching) {
              observer.complete();
            }
          },
          error: function error(_error) {
            var batchedErrors = R.pathOr([_error], ['response', 'parsed', 'errors'], _error);

            if (utils_1.hasUserNotFoundError(batchedErrors)) {
              handleUserNotExistError();
            } else {
              observer.error(_error);
            }
          },
          next: function next(data) {
            var errors = data.errors || [];

            if (utils_1.hasUserNotFoundError(errors)) {
              _this2.fetching = true;
              handleUserNotExistError();
            } else {
              observer.next(data);
            }
          }
        };
        subscription = forward(operation).subscribe(subscriber);
      });
    }
  }, {
    key: "sendSignUp",
    value: function sendSignUp(operation, forward) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this3 = this;

        var _this$getAuthState, email;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$getAuthState = this.getAuthState({
                  operation: operation
                }), email = _this$getAuthState.email;

                if (this.signUpPromise === null) {
                  this.signUpPromise = new Promise(function (resolve, reject) {
                    var signUpOperation = apollo_link_1.createOperation(operation.getContext(), {
                      query: mutations_1.SIGNUP_MUTATION,
                      variables: {
                        authProfileId: _this3.authProfileId,
                        user: {
                          email: email
                        }
                      }
                    });
                    forward(signUpOperation).subscribe({
                      complete: function complete() {
                        _this3.signUpPromise = null;
                        _this3.fetching = false;
                      },
                      error: reject,
                      next: function next(data) {
                        if (R.path(['data', 'userSignUp', 'id'], data)) {
                          resolve();
                        } else {
                          reject(data);
                        }
                      }
                    });
                  });
                }

                return _context.abrupt("return", this.signUpPromise);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return SignUpLink;
}(apollo_link_1.ApolloLink);

exports.SignUpLink = SignUpLink;